import { Navigate, useLocation } from 'react-router-dom'
import { SKIP_SUPABASE_AUTH } from '../lib/auth-config'
import { perfilHomePath, perfilPodeAcessarPath } from '../lib/perfilAcesso'
import { useAuth } from './AuthProvider'

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { session, profile, initializing, unauthorized } = useAuth()
  const location = useLocation()

  if (initializing) {
    return <div className="loading">Carregando sessão…</div>
  }

  if (SKIP_SUPABASE_AUTH) {
    return <>{children}</>
  }

  if (!session && !profile) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  if (unauthorized || !profile) {
    return <Navigate to="/acesso-negado" replace />
  }

  if (!perfilPodeAcessarPath(profile.perfil, location.pathname)) {
    return <Navigate to={perfilHomePath(profile.perfil)} replace />
  }

  return <>{children}</>
}
